import { render, staticRenderFns } from "./stemdo-components.component.vue?vue&type=template&id=5857bd81"
import script from "./stemdo-components.component.ts?vue&type=script&lang=ts&external"
export * from "./stemdo-components.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports